import { apiCall, apiCallAdmin } from "../services/api-service";

export const getDeleteApi = async (deleteUrl) => {
  return apiCall("delete", deleteUrl);
};
export const getDeleteAdminApi = async (deleteUrl) => {
  return apiCallAdmin("delete", deleteUrl);
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  return apiCall("delete", deleteUrl, { id: ids });
};

export const updateProfileImageApi = async (data) => {
  return apiCallAdmin("post", "user/image_update", data);
};
